// Shift 作成画面で使う 小さなプレゼンテーション部品
import { Button } from "@/components/ui/button";

export function Stat({ label, value, tone = "slate" }) {
  const t = {
    emerald: "bg-emerald-50 border-emerald-200 text-emerald-700",
    slate: "bg-slate-50 border-slate-200 text-slate-600",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-700",
    orange: "bg-orange-50 border-orange-200 text-orange-700",
    rose: "bg-rose-50 border-rose-200 text-rose-700",
    sky: "bg-sky-50 border-sky-200 text-sky-700",
  }[tone];
  return <div className={`border rounded p-2 ${t}`}><p className="text-[10px]">{label}</p><p className="text-xl font-bold">{value}</p></div>;
}

export function SummaryCard({ label, value, tone }) {
  const t = {
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sky: "bg-sky-100 text-sky-800 border-sky-200",
    amber: "bg-amber-100 text-amber-800 border-amber-200",
    rose: "bg-rose-100 text-rose-800 border-rose-200",
  }[tone];
  return (
    <div className={`border rounded p-2 text-center ${t}`}>
      <p className="text-[11px] font-semibold">{label}</p>
      <p className="text-xl font-bold mt-0.5">{value}人</p>
    </div>
  );
}

export function AssignmentChip({ value }) {
  if (!value) return <span className="text-[10px] bg-slate-100 text-slate-500 border border-slate-200 rounded px-1.5 py-0.5">未設定</span>;
  return <span className="text-[10px] bg-indigo-100 text-indigo-800 border border-indigo-200 rounded px-1.5 py-0.5">{value}</span>;
}

export function RequestTypeBadge({ type }) {
  if (type === "available") return <span className="text-[10px] bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-full px-2 py-0.5">◎ 入れます</span>;
  if (type === "either") return <span className="text-[10px] bg-sky-100 text-sky-800 border border-sky-200 rounded-full px-2 py-0.5">△ 必要なら</span>;
  if (type === "unavailable") return <span className="text-[10px] bg-rose-100 text-rose-800 border border-rose-200 rounded-full px-2 py-0.5">× 入れません</span>;
  return <span className="text-[10px] bg-slate-100 text-slate-500 border border-slate-200 rounded-full px-2 py-0.5">未提出</span>;
}

export function StatusBadge({ label, tone }) {
  const t = {
    green: "bg-emerald-100 text-emerald-800 border-emerald-200",
    purple: "bg-purple-100 text-purple-800 border-purple-200",
    orange: "bg-orange-100 text-orange-800 border-orange-200",
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    yellow: "bg-yellow-100 text-yellow-800 border-yellow-200",
    slate: "bg-slate-100 text-slate-600 border-slate-200",
  }[tone];
  return <span className={`text-[10px] border rounded px-1.5 py-0.5 ${t}`}>{label}</span>;
}

export function CheckCard({ title, items, count, tone, disabled, onDateClick }) {
  const cnt = count !== undefined ? count : (items?.length || 0);
  const t = {
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-800",
    purple: "bg-purple-50 border-purple-200 text-purple-800",
    rose: "bg-rose-50 border-rose-200 text-rose-800",
    orange: "bg-orange-50 border-orange-200 text-orange-800",
    slate: "bg-slate-50 border-slate-200 text-slate-700",
  }[tone];
  return (
    <div className={`border rounded p-3 ${t} ${disabled ? "opacity-50" : ""}`}>
      <p className="text-xs font-semibold">{title}</p>
      <p className="text-2xl font-bold mt-1">{cnt}<span className="text-xs ml-1">{items && !Array.isArray(items) ? "" : (cnt > 0 ? "人" : "")}</span></p>
      {items && items.length > 0 && (
        <p className="text-[11px] mt-1 opacity-80 line-clamp-2">
          {items.slice(0, 4).map((s) => s.display_name || s.name || (s.date ? s.date.slice(-2) + "日" : "?")).join("、")}
          {items.length > 4 ? ` 他${items.length - 4}` : ""}
        </p>
      )}
      {onDateClick && items?.[0]?.date && (
        <Button size="sm" variant="ghost" className="mt-1 h-6 text-[10px] px-2" onClick={() => onDateClick(items[0].date)}>詳細を見る</Button>
      )}
    </div>
  );
}
